import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '~/lang/en.json';
import fr from '~/lang/fr.json';
import de from '~/lang/de.json';
import es from '~/lang/es.json';
import da from '~/lang/da.json';
import sv from '~/lang/sv.json';
import nb from '~/lang/nb.json';

export const PLATFORM_LANGUAGE_STORAGE_KEY = 'karla-platform-language';
const supportedLanguages = ['en', 'fr', 'de', 'es', 'da', 'sv', 'nb'];

export const isPlatformLanguage = (language: unknown): language is string => typeof language === 'string' && supportedLanguages.includes(language);

export function getInitialPlatformLanguage(): string {
  if (typeof window === 'undefined') return 'en';

  try {
    const savedLanguage = window.localStorage.getItem(PLATFORM_LANGUAGE_STORAGE_KEY);
    if (isPlatformLanguage(savedLanguage)) return savedLanguage;
  } catch {
    // Storage may be unavailable in private browsing or restricted environments.
  }

  const browserLanguages = window.navigator.languages?.length ? window.navigator.languages : [window.navigator.language];
  return (
    browserLanguages
      .map((language) => language?.toLowerCase().split('-')[0])
      .map((language) => (language === 'no' ? 'nb' : language))
      .find(isPlatformLanguage) ?? 'en'
  );
}

export function rememberPlatformLanguage(language: unknown): void {
  if (!isPlatformLanguage(language) || typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(PLATFORM_LANGUAGE_STORAGE_KEY, language);
  } catch {
    // Language selection still works when browser storage is blocked.
  }
}

i18next.use(initReactI18next).init({
  lng: getInitialPlatformLanguage(),
  fallbackLng: 'en',
  resources: {
    en: { translation: en },
    fr: { translation: fr },
    de: { translation: de },
    es: { translation: es },
    da: { translation: da },
    sv: { translation: sv },
    nb: { translation: nb },
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18next;
